import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface DefaultEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function DefaultEntryValue({ value, inputLabel, size, className, ...props }: DefaultEntryValueProps) {
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <p
                className={cn(
                    "text-slate-900 dark:text-slate-200",
                    size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-md"
                )}
            >
                {value ?? "None"}
            </p>
        </BaseEntryValue>
    );
}
